export function calculateSplunkLoggingEnabled() {
  const chanceToEnableLogging = window.VISA_GLOBALS.splunkLoggingProbabilityValue;
  const test = Math.floor(Math.random() * 100) + 1;
  return test <= chanceToEnableLogging;
}
